exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b45074ce]:export{menuText:#bfcbd9;menuActiveText:#409EFF;subMenuActiveText:#f4f4f5;menuBg:#304156;menuHover:#263445;subMenuBg:#1f2d3d;subMenuHover:#001528;sideBarWidth:210px}.dialog-pop-view .el-dialog__body[data-v-b45074ce]{padding:0 4.375rem}[data-v-b45074ce] .el-dialog__header{height:4.375rem;line-height:4.375rem;padding:0;text-align:center;background:#f5f5f5}[data-v-b45074ce] .el-dialog__header .el-dialog__title{color:#999}\n", ""]);

// exports
